import { Clickable, Section } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledSection = styled(Section)`
  margin: auto;
  max-width: 84.5rem;
  padding: 0;
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledClickable = styled(Clickable)`
  color: ${({ theme }) => theme.colors.purple};
  font-size: 1.5rem;
  font-weight: bold;
  margin: 1.5rem 0 0;
  padding: 0 0.75rem;
  &:hover {
    background-color: ${({ theme }) => theme.colors.purple};
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
  }
`;
